import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../../../environments/environment';
import { CommonHttpService } from '../commonHttp.service';
import { LoaderService } from '../../_shared/services/loader.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit {
	baseUrl: any = environment.apiUrl;
	user: any = {};
  resetToken: any;
  userName: any;
  success: boolean = true
  errorMessage: any = ''

  constructor(private service: CommonHttpService, private router: Router, private route: ActivatedRoute, private loaderService: LoaderService) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
       this.resetToken = params['Key']
       this.userName = params['UserName']
    });
  }

  submit(){
    this.loaderService.display(true);
    this.user.LoginType = "Normal"
    this.user.ResetToken = this.resetToken
    this.user.UserName = this.userName
    this.service.create(this.baseUrl + 'LoginAPI/PasswordReset', this.user)
      .subscribe(
        data => {
           if(data.statusCode == 1){
            this.success = true
            this.router.navigate(['login']);
          }
          else{
            this.success = false
            this.errorMessage = data.responseMessage
          }
          this.loaderService.display(false);
        },
        (error) => {
          this.loaderService.display(false);
        })

  }

}



// WEBPACK FOOTER //
// C:/Ajatus WorkSpace/Now Grocery/now-grocery/NowGroceryStoreFront/src/app/components/reset-password/reset-password.component.ts